import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from "@mui/material";
import config from "../utils/config";
import { useEffect, useState } from "react";
import { styles } from "./component.styles";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import * as Proptypes from 'prop-types';
import { useTranslation } from "react-i18next";

export default function AppCurrencySelect({ currencies, cryptoCurrency, setCryptoCurrency }) {
    const [expanded, setExpanded] = useState(false);
    const [selected, setSelected] = useState(cryptoCurrency);
    const { t } = useTranslation();
    const getLogo = (currency) => {
        return `${config.S3_GYL_ICONS}/${currency.toLowerCase()}.svg`;
    };
    useEffect(() => {
        setCryptoCurrency(selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected])
    return <Accordion
        expanded={expanded}
        onChange={(_, expanded) => setExpanded(expanded)}
    >
        <AccordionSummary>
            {
                <Box
                    width={"100%"}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    {!!Object.keys(selected).length && (
                        <Box
                            display={"flex"}
                            flexDirection={"row"}
                            width={"80%"}
                        >
                            <img
                                src={getLogo(selected.currency)}
                                alt="icon"
                            />
                            <Box marginLeft={2}>
                                <Typography fontSize={12}>
                                    {
                                        selected?.payoutCurrency?.currency
                                            ?.fullTitle
                                    }
                                </Typography>
                                <Typography fontSize={10}>
                                    {selected?.currency}
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"center"}
                    >
                        {!!Object.keys(selected).length && (
                            <Box>
                                <Typography textAlign={"center"} fontSize={10}>
                                    {t("network")}
                                </Typography>
                                <Typography textAlign={"center"} fontSize={12}>
                                    {selected?.networkFullTitle?.toUpperCase() ||
                                        " --- "}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Box marginLeft={2}>
                        {!!expanded && <ArrowDropUp />}
                        {!expanded && <ArrowDropDown />}
                    </Box>
                </Box>
            }
        </AccordionSummary>
        <AccordionDetails sx={{ height: 200, overflowY: "auto" }}>
            {currencies &&
                currencies.map((val, index) => (
                    <ListItem
                        key={index}
                        onClick={() => {
                            setSelected(val);
                            setExpanded(false);
                        }}
                        style={
                            selected.id === val.id ? styles.selected : {}
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <img src={getLogo(val.currency)} alt="icon" />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={val?.payoutCurrency?.currency?.fullTitle}
                            secondary={val.currency}
                        />
                        <ListItemSecondaryAction sx={{ minWidth: "100px" }}>
                            <Typography fontSize={10}>{t("network")}</Typography>
                            <Typography fontSize={12}>
                                {val?.networkFullTitle?.toUpperCase() || " --- "}
                            </Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
        </AccordionDetails>
    </Accordion>
}

AppCurrencySelect.propTypes = {
    currencies: Proptypes.array,
    cryptoCurrency: Proptypes.object,
    setCryptoCurrency: Proptypes.func,
};
